import React, { useEffect } from 'react'
import Navbar from '../../Components/Navbar'
import SettingsSelector from './component/SettingSelector'
import SettingsContent from './component/SettingsContent'
import { useSettingsHook } from '../../Hooks/communicators/useSettingsHook'
import { useSelector } from 'react-redux'
import { useNavigationHook } from '../../Hooks/useNavigationHook'

export default function Settings() {
    const {
        accessToken,
        refreshToken,
        UID,
    } = useSelector((state: any) => state.auth.value);
    const {
        navigateTo,
    } = useNavigationHook();

    const {
        getAllData,
    } = useSettingsHook();

    const checkAuth = () => {
        if (accessToken === '' || refreshToken === '' || UID === '') {
            navigateTo('/');
        };
    };

    useEffect(() => {
        checkAuth();
        getAllData();
    }, []);


    return (
        <div>
            <Navbar />
            <SettingsSelector />
            <SettingsContent />
        </div >
    )
}
